import { render, staticRenderFns } from "./CurrentDay.vue?vue&type=template&id=20ab7962&scoped=true"
import script from "./CurrentDay.vue?vue&type=script&lang=js"
export * from "./CurrentDay.vue?vue&type=script&lang=js"
import style0 from "./CurrentDay.vue?vue&type=style&index=0&id=20ab7962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab7962",
  null
  
)

export default component.exports